// @ngInject
function Rms2ProductsApiService($q, $rootScope, DS, DSHttpAdapter, ResourcesService, $cookies, $window) {

    var endpoint = 'colourChange';

    return {
        getArticleColours: getArticleColours,
        createColourChange: createColourChange
    };

    function getArticleColours(articleId) {
        var deferred = $q.defer();

        var data = {
            articleId: articleId
        }
    
        DSHttpAdapter.GET(DS.defaults.rms2Path + endpoint + '/' + articleId).then(function (response) {
            console.log("GET Response: ", response);
            deferred.resolve(response.data);
        }, function (error) {
            deferred.reject(handleError(error));
        });
    
        return deferred.promise;
    }

    function createColourChange(request) {
        var deferred = $q.defer();

        DSHttpAdapter.POST(DS.defaults.rms2Path + endpoint, request).then(function (response) {
            deferred.resolve(response.data);
        }, function (error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function handleError(error) {
        return ResourcesService.handleResourceError(error);
    }
}

angular.module('rms2Products.api', [])
  .factory('Rms2ProductsApiService', Rms2ProductsApiService);